import { useTranslations } from 'next-intl';

import type { TicketModel } from '@/hooks/query';
import { addCommasWithFix } from '@/utils/odds-utils';

import { 
	TicketChoice, 
	SportBetTypeName, 
	Score, 
	TeamName 
} from '@/features/betslip/betslip-container/components/bet-ticket';
import { ConfirmBetTicketHeader } from '../confirm-bet-ticket-header';
import { SingleMatchParlayTicketDetails } from '@/features/single-match-parlay/components/single-match-parlay-ticket-details';
import { BetTicketOddsGroup } from '@/features/betslip/betslip-container/components/bet-ticket-odds-group';

interface ConfirmBetTicketSmpProps {
	ticket: TicketModel
}

export const ConfirmBetTicketSmp = ({ ticket }: ConfirmBetTicketSmpProps) => {
	const t = useTranslations('General');

	return (
		<>
			<ConfirmBetTicketHeader
				isParlay={false}
				tickets={[ticket]}
				status="running"
			/>

			<div className="ticket">
				<div className="ticket__wrap">
					<div className="ticket__status"></div>
					<div className="ticket__container">
						<div className="ticket__header">
							<div className="ticket__choice">{ticket.BettypeName}</div>
						</div>
						<div className="ticket__row">
							<SportBetTypeName ticket={ticket} />
							<Score ticket={ticket} />
						</div>
						<TeamName ticket={ticket} />
						<div className="ticket__row">
							<SingleMatchParlayTicketDetails choices={ticket.specialChoices ?? []} />
						</div>
						
						{ticket.ACCode ? (
							<div className="ticket__row">
								<div className="text-anti-counterfeiting-code">{ticket.ACCode}</div> 
							</div>
						) : null}
					</div>
					<BetTicketOddsGroup
						ticket={ticket}
						isParlayConfirmBet={false}
					/>
				</div>
			</div>

			<div className="betting-info">
				{ticket.TransId ? (
					<div className="ticket-id">
						{`${t('lbl_TicketID')} : ${ticket.TransId}`}
					</div>
				) : null}
				
				<div className="betting-info__group">
					<div className="betting-info__label">{t('lbl_stake')}</div>
					<div className="betting-info__amount">
						{addCommasWithFix(ticket.stake, 0)}
					</div>
				</div>
				<div className="betting-info__group">
					<div className="betting-info__label">
						{t('lbl_payout')}
					</div>
					<div className="betting-info__amount">
						{addCommasWithFix(ticket.payout, 2)}
					</div>
				</div>
			</div>
		</>
	);
};